import { shape, string } from 'prop-types';
import regionBasicInformationPropTypes from '../../region/proptypes/RegionPropTypes';

const cityBasicInformationPropTypes = {
  name: string,
  region: shape(regionBasicInformationPropTypes),
};

const cityBasicInformationDefaultProps = {
  name: null,
  region: null,
};

export default {cityBasicInformationPropTypes,cityBasicInformationDefaultProps};
